import { isOpenOrder } from './orderStatus';
import { ORDER_SIDES } from '../constants';
import { OrderItem } from '@libs/api-reference';

const calcMaximumQuantityInPortfolio = ({
  orders,
  isEditForm = false,
  quantity = 0,
  quantityOfPortfolio,
}: {
  orders: OrderItem[];
  isEditForm?: boolean;
  quantity?: number;
  quantityOfPortfolio: number;
}) => {
  const totalRemainingQuantity = orders.reduce((remainingQuantity, order) => {
    if (isOpenOrder(order) && ORDER_SIDES.sell === order.orderSideId) {
      const blockedQuantity = order.quantity - order.executedQuantity;
      remainingQuantity -= blockedQuantity;
    }

    return remainingQuantity;
  }, quantityOfPortfolio);

  return isEditForm
    ? totalRemainingQuantity + quantity
    : totalRemainingQuantity;
};

export { calcMaximumQuantityInPortfolio };
